
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Alert, AlertTitle } from '@mui/material';
import { useNavigate } from 'react-router-dom'

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Grid } from '@mui/material';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import CustomCard from 'Components/Card';

//Icons
import Success from '@mui/icons-material/CheckCircle';
import Error from '@mui/icons-material/Error';
import { copyToClipboard } from "Core/data/Helpers";

//Actions
import {
    bulkPairingSearchDevicesRequest,
    bulkPairingRequest,
    bulkPairingCloseModal,
    bulkPairingSearchIdRequest,
    clearRedux,
} from 'Redux/actions';

//Styles
import "./index.scss";

const BulkPairing = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const navigate = useNavigate();
    const formRef = useRef(null);

    const formVidfleet = useRef(null);
    const formGPS = useRef(null);

    const { loading, openModal, result, devices, camerasIds, gpsIds } = useSelector(state => state.bulkPairingRedux)

    const [type, setType] = useState("manual");
    const [cameras, setCamera] = useState([])
    const [final, setFinal] = useState(false);
    const [valueManual, setValueManual] = useState({ cameraEsn: "", gpsEsn: "" });
    const [vidfleetValue, setVidfleetValue] = useState("");
    const [gpsValue, setGpsValue] = useState("");
    const [invalidCameras, setInvalidCameras] = useState([]);
    const [invalidGps, setInvalidGps] = useState([]);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [currentType, setCurrentType] = useState(null)

    const handlePairing = () => {
        let payload = cameras.map((item) => ({ unitIdCamera: item.cameraId, unitIdGps: item.gpsId }))
        dispatch(bulkPairingRequest(payload));
    }

    const closeModal = () => {
        setType("manual");
        setCamera([]);
        setFinal(false);
        setValueManual({ cameraEsn: "", gpsEsn: "" });
        dispatch(bulkPairingCloseModal());
        dispatch(clearRedux("DEVICES_BULK_PAIRING"));
    }

    useEffect(() => {
        console.log("result", result)
        if (result?.transactionId) {
            //let currentCameras = cameras;
            /*result.map((item) => {
                let index = currentCameras.findIndex((camera) => camera?.cameraId === item?.unitIdCamera);
                if (index > -1) {
                    currentCameras[index].errorMessage = item?.errorMessage
                    currentCameras[index].errorCode = item?.errorCode
                }
            })*/
            let transactionId = result?.transactionId;
            let message = messages["devices_bulk_pairing_transaction_message"]
            NotificationManager.success(message, messages['devices_bulk_pairing_title'], 10000, () => {
                copyToClipboard(transactionId, messages['common_copied']);
                navigate(`/app/transactions/list/${transactionId}`);

            }, null, '', null);

            closeModal();
            
            //setFinal(true);
            //setCamera(currentCameras);
            //tableRef && tableRef?.current?.getData();
            //dispatch(clearRedux("DEVICES_BULK_PAIRING", { result: null }));
        }
        if (devices) {
            let currentCameras = cameras;
            let validateCamera = devices && devices.find((item) => item?.esn === valueManual?.cameraEsn);
            let validateGps = devices && devices.find((item) => item?.esn === valueManual?.gpsEsn);
            let validateCompany = validateCamera?.companyId === validateGps?.companyId;

            let cameraManufacturerValidation = validateCamera?.id
                ? validateCamera?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET" || validateCamera?.deviceModel?.manufacturer?.name?.toUpperCase() === "SMARTWITNESS" || validateCamera?.deviceModel?.manufacturer?.name?.toUpperCase() === "LIGHTMETRICS"
                : false

            let gpsManufacturerValidation = validateGps?.id
                ? validateGps?.deviceModel?.manufacturer?.name?.toUpperCase() !== "VIDFLEET" && validateGps?.deviceModel?.manufacturer?.name?.toUpperCase() !== "SMARTWITNESS" && validateGps?.deviceModel?.manufacturer?.name?.toUpperCase() !== "LIGHTMETRICS"
                : false

            let linkedModeValidation = validateCamera?.deviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET" || validateCamera?.deviceModel?.manufacturer?.name?.toUpperCase() === "SMARTWITNESS" || validateCamera?.deviceModel?.manufacturer?.name?.toUpperCase() === "LIGHTMETRICS";

            if (validateCamera && validateGps && cameraManufacturerValidation && gpsManufacturerValidation && validateCompany && validateCamera?.linkedMode) {
                let payload = {
                    cameraId: validateCamera?.id,
                    gpsId: validateGps?.id,
                    cameraLabel: validateCamera?.label,
                    gpsLabel: validateGps?.label,
                    esnCamera: validateCamera?.esn,
                    esnGps: validateGps?.esn,
                }
                currentCameras.push(payload)
                setCamera(currentCameras);
                setValueManual({ cameraEsn: "", gpsEsn: "" });
                let inputCamera = document.getElementById("bulkpai-esn-input");
                inputCamera && inputCamera.focus();
            }

            if (!validateCamera) {
                NotificationManager.error(
                    messages['devices_bulk_pairing_camera_is_invalid'],
                    messages['devices_bulk_pairing_title'],
                    5000
                );
                dispatch(clearRedux("DEVICES_BULK_PAIRING", { devices: null }));
                return
            }
            if (!validateGps) {
                NotificationManager.error(
                    messages['devices_bulk_pairing_gps_is_invalid'],
                    messages['devices_bulk_pairing_title'],
                    5000
                );
                dispatch(clearRedux("DEVICES_BULK_PAIRING", { devices: null }));
                return
            }
            if (!validateCompany) {
                NotificationManager.error(
                    messages['devices_bulk_error_same_company'],
                    messages['devices_bulk_pairing_title'],
                    5000
                );
                dispatch(clearRedux("DEVICES_BULK_PAIRING", { devices: null }));
                return
            }

            if (!cameraManufacturerValidation) {
                NotificationManager.error(
                    messages['devices_bulk_camera_manufacturer_must_vidfleet_smartwitness'],
                    messages['devices_bulk_pairing_title'],
                    5000
                );
                dispatch(clearRedux("DEVICES_BULK_PAIRING", { devices: null }));
                return
            }

            if (!gpsManufacturerValidation) {
                NotificationManager.error(
                    messages['devices_bulk_camera_manufacturer_must_diferent_vidfleet_smartwitness'],
                    messages['devices_bulk_pairing_title'],
                    5000
                );
                dispatch(clearRedux("DEVICES_BULK_PAIRING", { devices: null }));
                return
            }

            if (linkedModeValidation && !validateCamera?.linkedMode) {
                NotificationManager.warning(
                    messages['devices_bulk_camera_not_linked_mode'],
                    messages['devices_bulk_pairing_title'],
                    5000
                );
                dispatch(clearRedux("DEVICES_BULK_PAIRING", { devices: null }));
                return
            }
            dispatch(clearRedux("DEVICES_BULK_PAIRING", { devices: null }));
        }
        if (camerasIds) {
            let templateDevices = [];
            let devices = vidfleetValue.split(/[,; ]+/);
            devices = devices.filter((item) => item);
            let dataArr = new Set(devices);
            let result = [...dataArr];
            let currentCameras = cameras

            if (camerasIds?.length === result?.length) {
                let validateManufacturer = camerasIds.filter((item) => item?.deviceModel?.manufacturer?.name.toUpperCase() !== "VIDFLEET" && item?.deviceModel?.manufacturer?.name.toUpperCase() !== "SMARTWITNESS" && item?.deviceModel?.manufacturer?.name.toUpperCase() !== "LIGHTMETRICS")
                if (validateManufacturer.length > 0) {
                    NotificationManager.error(
                        messages['devices_bulk_cameras_must_be_vidfleet_or_smartWitness'],
                        messages['devices_bulk_pairing_title'],
                        5000
                    );
                    return
                }
                let validateLinkedMode = camerasIds.filter((item) => !item?.linkedMode)
                if (validateLinkedMode.length > 0) {
                    NotificationManager.warning(
                        messages['devices_bulk_cameras_must_be_in_paired_mode'],
                        messages['devices_bulk_pairing_title'],
                        5000
                    );
                    return
                }
                let validateCompany = camerasIds.filter((item) => item?.companyId !== camerasIds[0].companyId)
                if (validateCompany.length > 0) {
                    NotificationManager.error(
                        messages['devices_bulk_devices_must_be_from_the_same_company'],
                        messages['devices_bulk_pairing_title'],
                        5000
                    );
                    return
                }
                setVidfleetValue("");

                devices.map((item) => {
                    let currenDevice = camerasIds?.find(device => device?.esn === item)
                    if (currenDevice) {
                        templateDevices.push(currenDevice)
                    }
                })

                let newDevices = templateDevices.map((item) => {
                    return {
                        cameraId: item?.id,
                        cameraLabel: item?.label,
                        esnCamera: item?.esn,
                        companyId: item?.companyId,
                        gpsId: null,
                        gpsLabel: null,
                        esnGps: null,
                    }
                });
                setInvalidCameras([])
                currentCameras.push(...newDevices);
                setCamera(currentCameras);
            } else {
                const invalid = result.filter(item => !camerasIds.some(obj => obj?.esn === item));
                if (invalid.length) setInvalidCameras(invalid)

                NotificationManager.error(
                    messages['devices_bulk_esn_the_cameras_entered_must_be_valid'],
                    messages['devices_bulk_pairing_title'],
                    5000
                );
            }
            dispatch(clearRedux("DEVICES_BULK_PAIRING", { camerasIds: null }));
        }
        if (gpsIds) {
            let templateDevices = [];
            let devices = gpsValue.split(/[,; ]+/);
            devices = devices.filter((item) => item);
            let dataArr = new Set(devices);
            let result = [...dataArr];
            if (gpsIds?.length === result?.length) {
                let validateManufacturerGps = gpsIds.filter((item) => item?.deviceModel?.manufacturer?.name.toUpperCase() === "VIDFLEET" || item?.deviceModel?.manufacturer?.name.toUpperCase() === "SMARTWITNESS")
                if (validateManufacturerGps.length > 0) {
                    NotificationManager.error(
                        messages['devices_bulk_gps_must_be_different_from_vidfleet_or_smartWitness'],
                        messages['devices_bulk_pairing_title'],
                        5000
                    );
                    return
                }

                let validateCompany = gpsIds.filter((item) => item?.companyId !== cameras[0].companyId)
                if (validateCompany.length > 0) {
                    NotificationManager.error(
                        messages['devices_bulk_devices_must_be_from_the_same_company'],
                        messages['devices_bulk_pairing_title'],
                        5000
                    );
                    return
                }

                setGpsValue("");
                let currentCameras = cameras;

                devices.map((item) => {
                    let currenDevice = gpsIds?.find(device => device?.esn === item)
                    if (currenDevice) {
                        templateDevices.push(currenDevice)
                    }
                })

                currentCameras = currentCameras.map((item, index) => {
                    let newValue = templateDevices[index]
                    return {
                        ...item,
                        esnGps: newValue?.esn,
                        gpsId: newValue?.id,
                        gpsLabel: newValue?.label
                    }
                })
                setInvalidGps([])
                setCamera(currentCameras)
            } else {
                const invalid = result.filter(item => !gpsIds.some(obj => obj?.esn === item));
                if (invalid.length) setInvalidGps(invalid)

                NotificationManager.error(
                    messages['devices_bulk_esn_the_cameras_entered_must_be_valid'],
                    messages['devices_bulk_pairing_title'],
                    5000
                );
            }
            dispatch(clearRedux("DEVICES_BULK_PAIRING", { gpsIds: null }));
        }
    }, [result, devices, camerasIds, gpsIds])

    let validatePairing = cameras.some((item) => item.cameraId !== null && item.gpsId !== null);

    return (
        <>
            <Modal
                open={openModal}
                title={messages['devices_bulk_pairing_title']}
                handleClose={() => closeModal()}
                position="right"
                size="small"
                loading={loading}
            >
                <ModalBody>
                    <div style={{ padding: '0 10px', marginBottom: 40 }}>
                        <Grid
                            container
                            direction="row"
                        >
                            {
                                !final &&
                                <Grid item xs={12}>
                                    <div className='filters-type'>
                                        <FormControlLabel
                                            value={true}
                                            control={<Radio onClick={() => {
                                                if (type !== "manual") {
                                                    if (cameras.length) {
                                                        setCurrentType("manual");
                                                        setOpenModalConfirm(true);
                                                    } else {
                                                        setValueManual({ cameraEsn: "", gpsEsn: "" });
                                                        setVidfleetValue("");
                                                        setGpsValue("");
                                                        setType("manual");
                                                    }
                                                }

                                            }} checked={type === "manual"} color="primary" />}
                                            label={messages['devices_bulk_pairing_manual']}
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            value="start"
                                            control={<Radio onClick={() => {
                                                if (type !== "copypaste") {
                                                    if (cameras.length) {
                                                        setCurrentType("copypaste");
                                                        setOpenModalConfirm(true);
                                                    } else {
                                                        setValueManual({ cameraEsn: "", gpsEsn: "" });
                                                        setVidfleetValue("");
                                                        setGpsValue("");
                                                        setType("copypaste");
                                                    }
                                                }
                                            }} checked={type === "copypaste"} color="primary" />}
                                            label={messages['devices_bulk_pairing_copy_paste']}
                                            labelPlacement="end"
                                        />
                                    </div>
                                </Grid>
                            }
                            {
                                <Alert
                                    style={{ marginBottom: 5, marginTop: 5 }}
                                    severity="error"
                                >
                                    <AlertTitle>{messages['devices_bulk_pairing_timezone_assign']}</AlertTitle>
                                </Alert>
                            }
                            {
                                type === "manual" && !final &&
                                <Grid item xs={12}>
                                    <Form
                                        ref={formRef}
                                        onValidSubmit={() => {
                                            let currentCameras = cameras;
                                            let cameraValidation = currentCameras.some((device) => device.esnCamera === valueManual.cameraEsn);
                                            let gpsValidation = currentCameras.some((device) => device.esnGps === valueManual.gpsEsn);
                                            if (cameraValidation) {
                                                NotificationManager.warning(
                                                    messages['devices_bulk_pairing_esn_already_added'],
                                                    messages['devices_bulk_pairing_title'],
                                                    5000
                                                );
                                                return
                                            }
                                            if (gpsValidation) {
                                                NotificationManager.warning(
                                                    messages['devices_bulk_pairing_gps_already_added'],
                                                    messages['devices_bulk_pairing_title'],
                                                    5000
                                                );
                                                return
                                            }
                                            if (valueManual.cameraEsn?.trim() === valueManual.gpsEsn?.trim()) {
                                                NotificationManager.warning(
                                                    messages['devices_bulk_same_as_that_of_gps'],
                                                    messages['devices_bulk_pairing_title'],
                                                    5000
                                                );
                                                return
                                            }
                                            dispatch(bulkPairingSearchDevicesRequest({ cameraEsn: valueManual.cameraEsn?.trim(), gpsEsn: valueManual.gpsEsn?.trim() }))

                                        }}
                                    >
                                        <Grid container>
                                            <Grid className="bulk-grid" item xs={5}>
                                                <Input
                                                    id="bulkpai-esn-input"
                                                    label={messages['devices_bulk_pairing_vidfleet_esn']}
                                                    placeholder={messages['devices_bulk_pairing_vidfleet_esn']}
                                                    required
                                                    requiredMessage={messages['required_field']}
                                                    value={valueManual.cameraEsn}
                                                    onChange={(value) => {
                                                        let currentCamera = valueManual;
                                                        currentCamera.cameraEsn = value
                                                        setValueManual({ ...currentCamera })
                                                    }}
                                                    maxLength={15}
                                                    style={{ color: 'red' }}
                                                />
                                            </Grid>
                                            <Grid className="bulk-grid" item xs={5}>
                                                <Input
                                                    label={messages['devices_bulk_pairing_gps_esn']}
                                                    placeholder={messages['devices_bulk_pairing_gps_esn']}
                                                    required
                                                    requiredMessage={messages['required_field']}
                                                    value={valueManual.gpsEsn}
                                                    onChange={(value) => {
                                                        let currentGps = valueManual;
                                                        currentGps.gpsEsn = value
                                                        setValueManual({ ...currentGps })
                                                    }}
                                                    maxLength={15}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <div className="bulk-button-container" style={{ marginTop: 25 }}>
                                                    <Button
                                                        className="btn-dark-blue"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            formRef?.current?.submit();
                                                        }}
                                                    >
                                                        {messages['devices_bulk_pairing_add']}
                                                    </Button>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                </Grid>
                            }
                            {
                                type === "copypaste" && !final &&
                                <Grid item xs={12}>
                                    <Form
                                        ref={formVidfleet}
                                        onValidSubmit={() => {
                                            let devices = vidfleetValue.split(/[,; ]+/);
                                            devices = devices?.filter((item) => item);
                                            let dataArr = new Set(devices);
                                            let result = [...dataArr];
                                            let validateDevices = null
                                            result.map((item) => validateDevices = cameras?.findIndex((camera) => camera?.esnCamera === item))
                                            if (validateDevices > -1) {
                                                NotificationManager.warning(
                                                    messages['devices_bulk_pairing_esn_already_added'],
                                                    messages['devices_bulk_pairing_title'],
                                                    3000
                                                );
                                                return
                                            }
                                            dispatch(bulkPairingSearchIdRequest(result, "camera"))
                                        }}
                                    >
                                        <Grid container spacing={1}>
                                            <Grid item xs={10}>
                                                <Input
                                                    label={messages['devices_bulk_esn_of_cameras']}
                                                    placeholder={messages['devices_bulk_esn_of_cameras']}
                                                    required
                                                    requiredMessage={messages['required_field']}
                                                    value={vidfleetValue}
                                                    onChange={(value) => setVidfleetValue(value)}
                                                    maxLength={2000}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <div className="bulk-button-container" style={{ marginTop: 25 }}>
                                                    <Button
                                                        className="btn-dark-blue"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            formVidfleet?.current?.submit();
                                                            setInvalidCameras([])
                                                        }}
                                                        disabled={validatePairing}
                                                    >
                                                        {messages['devices_bulk_pairing_add']}
                                                    </Button>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                    <Form
                                        ref={formGPS}
                                        onValidSubmit={() => {
                                            let devices = gpsValue.split(/[,; ]+/);
                                            devices = devices.filter((item) => item);
                                            let dataArr = new Set(devices);
                                            let result = [...dataArr];
                                            if (cameras.length !== result.length) {
                                                NotificationManager.warning(
                                                    messages['devices_bulk_number_gps_does_not_match_the_number_of_cameras_entered'],
                                                    messages['devices_bulk_pairing_title'],
                                                    5000
                                                );
                                                return
                                            }

                                            const validateCameras = result.filter(item => {
                                                return cameras.some(obj => obj?.esnCamera === item);
                                            });

                                            if (validateCameras?.length) {
                                                NotificationManager.warning(
                                                    messages['devices_bulk_gps_vs_cameras_message'],
                                                    messages['devices_bulk_pairing_title'],
                                                    3000
                                                );
                                                return
                                            }

                                            dispatch(bulkPairingSearchIdRequest(result, "gps"))
                                        }}
                                    >
                                        <Grid container spacing={1}>
                                            <Grid item xs={10}>
                                                <Input
                                                    label={messages['devices_bulk_esn_of_gps']}
                                                    placeholder={messages['devices_bulk_esn_of_gps']}
                                                    required
                                                    requiredMessage={messages['required_field']}
                                                    value={gpsValue}
                                                    onChange={(value) => setGpsValue(value)}
                                                    maxLength={2000}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <div className="bulk-button-container" style={{ marginTop: 25 }}>
                                                    <Button
                                                        className="btn-dark-blue"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            formGPS?.current?.submit();
                                                            setInvalidGps([]);
                                                        }}
                                                        disabled={cameras.length === 0 || validatePairing}
                                                    >
                                                        {messages['devices_bulk_pairing_add']}
                                                    </Button>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                </Grid>
                            }
                        </Grid>
                        {
                            invalidCameras?.length ?
                                <Alert
                                    style={{ marginBottom: 5, marginTop: 5 }}
                                    severity="error"
                                >
                                    <AlertTitle>{messages['devices_bulk_there_are_invalid_esn']}</AlertTitle>
                                    <ul style={{ marginBottom: 0, paddingLeft: 15 }}>
                                        {invalidCameras.map((item, index) => {
                                            return <li key={index}>{item}</li>
                                        })}
                                    </ul>
                                </Alert>
                                : <></>
                        }
                        {
                            invalidGps?.length ?
                                <Alert
                                    style={{ marginBottom: 5, marginTop: 5 }}
                                    severity="error"
                                >
                                    <AlertTitle>{messages['devices_bulk_there_are_invalid_esn']}</AlertTitle>
                                    <ul style={{ marginBottom: 0, paddingLeft: 15 }}>
                                        {invalidGps.map((item, index) => {
                                            return <li key={index}>{item}</li>
                                        })}
                                    </ul>
                                </Alert>
                                : <></>
                        }
                        {
                            type === "copypaste" && !final && !cameras?.length &&
                            <Alert
                                style={{ marginBottom: 5, marginTop: 5 }}
                                severity="info"
                            >
                                {messages['devices_bulk_rule_pairing']}
                            </Alert>
                        }

                        {
                            cameras?.length > 0 ? cameras.map((item, index) => {
                                return (
                                    <CustomCard
                                        key={index}
                                        onClick={() => {
                                            let current = cameras.lastIndexOf(item);
                                            let currentCamera = cameras
                                            currentCamera.splice(current, 1);
                                            setCamera([...currentCamera]);
                                        }}
                                        hideButton={final}
                                    >
                                        <div style={{ display: 'grid' }}>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_bulk_pairing_vidfleet_esn']}</label><span>{item.esnCamera}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_bulk_pairing_gps_esn']}</label><span>{item.esnGps}</span>
                                            </div>
                                            {
                                                final &&
                                                <>
                                                    {
                                                        item?.errorMessage
                                                            ?
                                                            <div>
                                                                <label style={{ fontWeight: 700, marginRight: 5 }}>Message</label>
                                                                <Error style={{ marginRight: 5, color: '#c94747' }} />
                                                                <span>{item.errorMessage}</span>
                                                            </div>
                                                            :
                                                            <div>
                                                                <label style={{ fontWeight: 700, marginRight: 5 }}>Message</label>
                                                                <Success style={{ marginRight: 5, color: '#52C6AD' }} />
                                                                <span>{messages['devices_bulk_pairing_paired']}</span>
                                                            </div>
                                                    }
                                                </>
                                            }
                                        </div>
                                    </CustomCard>
                                )
                            }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['no_devices_added']}</span></div>
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className={!final ? "btn-cancel" : "btn-dark-blue"}
                        onClick={(e) => {
                            e.preventDefault();
                            closeModal();
                        }}
                    >
                        {messages['close']}
                    </Button>
                    {
                        !final &&
                        <Button
                            className="btn-dark-blue"
                            onClick={(e) => {
                                e.preventDefault();
                                handlePairing()
                            }}
                            disabled={cameras?.length === 0 || !validatePairing}
                        >
                            {messages['devices_bulk_pairing_pair_devices']}
                        </Button>
                    }
                </ModalFooter>
            </Modal>

            <Modal
                open={openModalConfirm}
                title={messages['devices_bulk_pairing_title']}
                handleClose={() => setOpenModalConfirm(false)}
                position="right"
                size="small"
                loading={loading}
            >
                <ModalBody>
                    <div style={{ padding: '0 10px', marginBottom: 40 }}>
                        {messages['devices_bulk_confirm_change_type']}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-cancel"
                        onClick={(e) => {
                            setOpenModalConfirm(false)
                            setCurrentType(null)
                        }}
                    >
                        {messages['close']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => {
                            setValueManual({ cameraEsn: "", gpsEsn: "" })
                            setVidfleetValue("");
                            setGpsValue("");
                            setOpenModalConfirm(false);
                            setType(currentType);
                            setCurrentType(null);
                            setCamera([]);
                        }}
                    >
                        {messages['common_continue']}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default BulkPairing;